// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center[data-v-12479a17] {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n}\n.permission-container[data-v-12479a17] {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
